<template>
  <div class="table-wrapper p-md-2">
    <validation-observer ref="observer">
      <table class="table">
        <tr>
          <th>郵便番号</th>
          <td>
            <div class="row">
              <div class="col-4 col-md-3">
                <validation-provider
                  v-slot="{ errors }"
                  rules="numeric|digits:3"
                  name="YUBIN1"
                >
                  <b-form-input
                    ref="YUBIN1"
                    type="tel"
                    maxlength="3"
                    v-model="form.other.YUBIN1"
                    :state="errors.length ? false : null"
                    placeholder="160"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <span class="py-2">-</span>
              <div class="col-4 col-md-3">
                <validation-provider
                  v-slot="{ errors }"
                  rules="numeric|digits:4"
                  name="YUBIN2"
                >
                  <b-form-input
                    ref="YUBIN2"
                    type="tel"
                    maxlength="4"
                    v-model="form.other.YUBIN2"
                    :state="errors.length ? false : null"
                    placeholder="0023"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <button
                type="button"
                class="btn btn-success bold"
                @click="searchAddress"
                :disabled="!isYubinSearch"
                style="height: 40px"
              >
                検索
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            都道府県
            <br v-if="!isMobile" />
            市区町村
            <span class="must">必須</span>
          </th>
          <td>
            <div class="row">
              <div class="col-md-7 col-lg-3">
                <validation-provider
                  name="TODO_CD"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <b-form-select
                    ref="TODO_CD"
                    v-model="form.other.TODO_CD"
                    :state="errors.length ? false : null"
                    :options="prefList"
                    trim
                    @change="changePref"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>

              <div class="col-md-8 col-lg-5 mt-2 mt-lg-0">
                <validation-provider
                  name="SHIKU_CD"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <b-form-select
                    ref="SHIKU_CD"
                    :disabled="!cityList.length"
                    v-model="form.other.SHIKU_CD"
                    :state="errors.length ? false : null"
                    :options="cityList"
                    trim
                    @change="changeCity"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            個人宅
            <span v-if="isMeihen">または一般企業（自動車販売店を除く）</span>
            ですか？
          </th>
          <td>
            <div class="mt-2">
              <md-checkbox
                class="md-primary"
                v-model.number="form.other.IS_PERSONAL"
                :value="1"
              >
                はい
              </md-checkbox>
            </div>
          </td>
        </tr>
      </table>
    </validation-observer>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin'
import Constant from '@/const'
import _ from 'lodash'
import Store from '@/store/index.js'

export default {
  name: 'OrderDirect',
  components: {},
  props: {
    /** 入力データ */
    form: {
      type: Object,
      default: null,
    },

    /** 名変フラグ */
    isMeihen: {
      type: Number,
      default: 0,
    },

    /** エラーが存在するか取得するフラグ */
    isInvalidActive: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [Mixin],

  data: () => ({
    /** 市区町村リスト */
    cityList: [],

    /** オブザーバー */
    observer: null,

    search: {
      TODO_CD: '',
      AA_KAISAI_BI: '',
    },
  }),
  methods: {
    /** 都道府県変更 */
    changePref() {
      const todoCd = this.form.other.TODO_CD
      this.form.other.TODO_MEI = null
      this.form.other.SHIKU_CD = ''
      this.form.other.SHIKU_MEI = null
      if (todoCd) {
        this.form.other.TODO_MEI = this.getText(this.prefList, todoCd)
        this.getCityList()
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.form.other.SHIKU_CD
      this.form.other.SHIKU_MEI = null
      if (shikuCd) {
        this.form.other.SHIKU_MEI = this.getText(this.cityList, shikuCd)
      }
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.form.other.TODO_CD) return
      return Store.dispatch(
        'address/getCityList',
        this.form.other.TODO_CD
      ).then(() => {
        const cityList = _.cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        this.cityList = cityList
      })
    },

    /** 郵便番号検索 */
    searchAddress() {
      this.getAreaFromZipCd(
        `${this.form.other.YUBIN1}${this.form.other.YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.form.other.TODO_CD = ('00' + item.prefcode).slice(-2)
          this.form.other.TODO_MEI = this.getText(
            this.prefList,
            this.form.other.TODO_CD
          )
          this.form.other.SHIKU_MEI = item.address2
          this.form.other.BANCHI = item.address3
          await this.getCityList()
          const city = this.getParam(
            this.cityList,
            this.form.other.SHIKU_MEI,
            'text'
          )
          if (city) this.form.other.SHIKU_CD = city.value
        }
      })
    },
  },

  computed: {
    isPersonal() {
      return this.form.other.IS_PERSONAL
    },

    /** 郵便検索可能か */
    isYubinSearch() {
      return (
        this.form.other.YUBIN1 &&
        this.form.other.YUBIN2 &&
        this.observer &&
        this.observer.fields.YUBIN1 &&
        this.observer.fields.YUBIN2 &&
        !this.observer.fields.YUBIN1.failed &&
        !this.observer.fields.YUBIN2.failed
      )
    },
  },
  watch: {
    isPersonal(val) {
      if (Number(val)) {
        this.form.other.YUSO_KBN = Constant.YUSOKBN.KOJIN
      } else {
        this.form.other.YUSO_KBN = ''
      }
    },

    /** エラーが存在するか取得するフラグ監視 */
    async isInvalidActive(val) {
      if (val) {
        const valid = await this.observer.validate()
        this.$emit('setInvalid', !valid)
      }
    },
  },

  mounted() {
    this.observer = this.$refs.observer
    this.getCityList()
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.table-wrapper
  //overflow: auto
.md-checkbox
  margin: 0
.form-check-inline
  margin-right: 5px
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
  td
    width: 68%
</style>



// WEBPACK FOOTER //
// src/components/trial/Direct.vue